import { render, staticRenderFns } from "./PatientFormAdverseEvent.vue?vue&type=template&id=3ab3e5ff"
import script from "./PatientFormAdverseEvent.vue?vue&type=script&lang=js"
export * from "./PatientFormAdverseEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports